import React, { useEffect, useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "./historic.css";
import { useForm, Controller } from "react-hook-form";
import CustomDOBPicker from "../../components/CustomDOBPicker";
import axios from "axios";
import base_url from "../../api/bootapi";
import AsyncSelect from "react-select/async";
import CustomButton from "../../components/CustomButton";
import moment from "moment";
import FlightCard from "./FlightCard";
import { Loader, Modal, Radio } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import {
  IconChartBar,
  IconLiveView,
  IconTemperatureSun,
} from "@tabler/icons-react";
import FlightRouteCard from "./FlightRouteCard";
import FlightStatsDetails from "./FlightStatsDetails";


import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useDisclosure } from "@mantine/hooks";

const FlightTracking = () => {
    useEffect(()=>{window.scrollTo(0,0)},[])

  const {
    register:flightFormRegister,
    handleSubmit:flightFormHandleSubmit,
    control: flightFormControl,
     reset: resetFlightForm,    
    formState: { errors:flightFormErrors },
  } = useForm({
    defaultValues: {
      airline: "",
      flightNumber: "",
      departureDate: moment().format("MM-DD-YYYY"),
    },
  });


    const {
    register:airportFormRegister,
    handleSubmit:airportFormHandleSubmit,
      control: airportFormControl,
     reset: resetAirportForm,    
    formState: { errors:airportFormErrors },
  } = useForm({
    defaultValues: {
      // airline: "",
      arrivalAirport: "",
      departureAirport:"",
      // time:null,
      date: moment().format("MM-DD-YYYY"),

    },
  });

  const [defaultAirlineOptions, setDefaultAirlineOptions] = useState([]);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [flightData, setFlightData] = useState(null);
  const [searchBy, setSearchBy] = useState('airline_name');

  const [searchMethod, setSearchMethod] = useState('by_flight');
  const timeOptions = [
  { value: "00:00-06:00", label: "00:00-06:00" },
  { value: "06:00-12:00", label: "06:00-12:00" },
  { value: "12:00-18:00", label: "12:00-18:00" },
  { value: "18:00-00:00", label: "18:00-00:00" },
];

  const [loading, setLoading] = useState(false);

  // const onSubmit = async (data) => {
  //   setLoading(true);

  //   const requestData = {
  //     airline_code: data.airline.hub_code,
  //     flight_number: data.flightNumber,
  //     flight_date: moment(data.departureDate, "MM-DD-YYYY").format(
  //       "YYYY/MM/DD"
  //     ),
  //   };

  //   try {
  //     const response = await axios.post(
  //       `${base_url.api1}/tourapp/flight_states`,
  //       requestData
  //     );

  //     const flightData = response.data?.schedule;
  //     console.log(flightData);

  //     const airports = flightData.appendix?.airports ?? [];
  //     console.log(flightData.appendix);
  //     console.log(flightData.appendix?.airports);

  //     let flightOptionsData = null;

  //     if (flightData?.flightStatuses?.length > 0) {
  //       console.log("Calling");
  //       const departureFsCode =
  //         flightData?.flightStatuses[0]?.departureAirportFsCode;
  //       const arrivalFsCode =
  //         flightData?.flightStatuses[0]?.arrivalAirportFsCode;

  //       const departureAirport = airports.find(
  //         (a) => a.fs === departureFsCode
  //       )?.name;
  //       const arrivalAirport = airports.find(
  //         (a) => a.fs === arrivalFsCode
  //       )?.name;

  //       const departureScheduled =
  //         flightData?.flightStatuses[0]?.operationalTimes
  //           ?.scheduledGateDeparture?.dateLocal;
  //       const departureEstimated =
  //         flightData?.flightStatuses[0]?.operationalTimes
  //           ?.estimatedGateDeparture?.dateLocal;
  //       const departureActual =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualGateDeparture
  //           ?.dateLocal;

  //       const departureActualRunway =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualRunwayDeparture
  //           ?.dateLocal;
  //       const arrivalScheduled =
  //         flightData?.flightStatuses[0]?.operationalTimes?.scheduledGateArrival
  //           ?.dateLocal;
  //       const arrivalEstimated =
  //         flightData?.flightStatuses[0]?.operationalTimes?.estimatedGateArrival
  //           ?.dateLocal;
  //       const arrivalActual =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualGateArrival
  //           ?.dateLocal;
  //       const arrivalActualRunway =
  //         flightData?.flightStatuses[0]?.operationalTimes?.actualRunwayArrival
  //           ?.dateLocal;
  //       const status = flightData?.flightStatuses[0]?.status;
  //       const flightDate =
  //         flightData?.flightStatuses[0]?.departureDate?.dateLocal;
  //       const flightNumber =
  //         flightData?.flightStatuses[0]?.primaryCarrierFsCode +
  //         " " +
  //         flightData?.flightStatuses[0]?.flightNumber;
  //       const departureTerminal =
  //         flightData?.flightStatuses[0]?.airportResources?.departureTerminal;
  //       const arrivalTerminal =
  //         flightData?.flightStatuses[0]?.airportResources?.arrivalTerminal;

  //       const departureTimezone = airports.find(
  //         (a) => a.fs === departureFsCode
  //       )?.timeZoneRegionName;
  //       const arrivalTimezone = airports.find(
  //         (a) => a.fs === arrivalFsCode
  //       )?.timeZoneRegionName;
  //       console.log(
  //         departureFsCode,
  //         arrivalFsCode,
  //         departureAirport,
  //         arrivalAirport
  //       );

  //       flightOptionsData = [
  //         {
  //           flight_status: status,
  //           flight_date: flightDate,
  //           flight_number: flightNumber,
  //           departure: {
  //             airport: departureAirport,
  //             iata: departureFsCode,
  //             scheduled: departureScheduled,
  //             estimated: departureEstimated,
  //             actual: departureActual,
  //             actual_runway: departureActualRunway,

  //             terminal: departureTerminal,
  //             timezone: departureTimezone,
  //           },
  //           arrival: {
  //             airport: arrivalAirport,
  //             iata: arrivalFsCode,
  //             scheduled: arrivalScheduled,
  //             estimated: arrivalEstimated,
  //             actual: arrivalActual,
  //             actual_runway: arrivalActualRunway,
  //             terminal: arrivalTerminal,
  //             timezone: arrivalTimezone,
  //           },
  //         },
  //       ];
  //     }
  //     setFlightData(flightOptionsData);
  //     setLoading(false);
  //   } catch (error) {
  //     setFlightData(null);
  //     setLoading(false);
  //     console.error("Error fetching flight options:", error);
  //   }
  // };


   const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

    const fetchAirports = async (inputValue) => {
      if (inputValue.length > 0) {
        try {
          const response = await axios.get(
            `${base_url.api1}/tourapp/flight_states_airports?search=${inputValue}&sortby=airport_name`
          );
          if (response.data && response.data.Airports) {
            return response.data.Airports.map((airport) => ({
              value: airport.id,
              label: `${airport.airport_name.replace(
                /[\n\u0000-\u001F\u007F-\u009F]/g,
                ""
              )} (${airport.iata_code})`,
              iata_code: airport?.iata_code,
              icao_code: airport?.icao_code,
            }));
          }
        } catch (error) {
          console.error("Error fetching airports:", error);
        }
      }
      return [];
    };

  
  useEffect(() => {
  const airlineFormData = localStorage.getItem("airlineFormData");
  if (airlineFormData) {
    resetFlightForm(JSON.parse(airlineFormData));
    }
    

     const airportFormData = localStorage.getItem("airportFormData");
  if (airportFormData) {
    resetAirportForm(JSON.parse(airportFormData));
    }
    

       const searchMethod = localStorage.getItem("searchMethod");
  if (searchMethod) {
    setSearchMethod(JSON.parse(searchMethod));
  } else {
    setSearchMethod('by_flight')
  }
}, []);
  
  
const [flightDataRoute, setFlightDataRoute] = useState(null);
  const airportFormOnSubmit = async (data) => {
    console.log(data)
      localStorage.setItem("airportFormData", JSON.stringify(data));

    setLoading(true);

    const requestData = {
      departure_airport: data.departureAirport.icao_code,
      arrival_airport: data.arrivalAirport.icao_code,
      flight_date: moment(data.date, "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      ),
    };

    try {
      const response = await axios.post(
        `${base_url.api1}/users/org_flight_stats_live_tracking`,
        requestData
      );

   const flightData = response.data?.Flight
     

setFlightDataRoute(flightData);
    console.log(flightData)
      
      setLoading(false);
    } catch (error) {
      setFlightDataRoute([]);
      setLoading(false);
      console.error("Error fetching flight options:", error);
    }
  
  }
  const onSubmit = async (data) => {
      localStorage.setItem("airlineFormData", JSON.stringify(data));
      
    setLoading(true);

    const requestData = {
      airline_code: data?.airline?.icao_code,
      flight_number: data.flightNumber,
      flight_date: moment(data.departureDate, "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      ),
    };

    try {
      const response = await axios.post(
        `${base_url.api1}/users/org_flight_stats_live_tracking`,
        requestData
      );

  //     const flightData = response.data?.Flight?.filter(flightData => {
  //   const departureScheduled = flightData?.operationalTimes?.scheduledGateDeparture?.dateLocal || flightData?.operationalTimes?.publishedDeparture?.dateLocal;
  //  console.log(departureScheduled)
  //       if (!departureScheduled) return false;
  //   const depDate = new Date(departureScheduled).toISOString().slice(0, 10);
  //   return depDate === moment(data.departureDate, "MM-DD-YYYY").format(
  //       "YYYY-MM-DD"
  //     ) ;
  // });

      
      const flightData = response.data?.Flight;
     
     

setFlightData(flightData);
      // const flightData = response.data?.Flight[0];
     
 setLoading(false);

      return
    
    } catch (error) {
      setFlightData([]);
      setLoading(false);
      console.error("Error fetching flight options:", error);
    }
  };

  const validateDateFormat = (value) => {
    const mmddyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    // const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    // Check format
    if (!mmddyyyy.test(value)) {
      return "Date must be in mm-dd-yyyy format";
    }

    // // Parse date depending on format
    // let parts;
    // let parsedDate;

    // if (ddmmyyyy.test(value)) {
    //   parts = value.split("-");
    //   parsedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // yyyy-mm-dd
    // } else {
    //   parsedDate = new Date(value);
    // }

    // // Normalize time
    // parsedDate.setHours(0, 0, 0, 0);
    // const today = new Date();
    // today.setHours(0, 0, 0, 0);

    // if (parsedDate < today) {
    //   return "Date cannot be in the past";
    // }

    return true;
  };

  const loadAirlineOptions = (inputValue, callback) => {
    fetchAirlines(inputValue).then((options) => callback(options));
  };

const fetchAirlines = async (inputValue) => {
  if (inputValue.length === 0) return [];

  try {
    const response = await axios.get(
      `${base_url.api1}/tourapp/flight_states_airlines?${searchBy}=${inputValue}`
    );

    if (!response.data || !response.data.Airlines) return [];

    const airlines = response.data.Airlines.map((airline) => ({
      value: airline.id,
      label: `${airline.airline_name} ${
        airline.iata_code ? `(${airline.iata_code})` : ""
      }`,
      airline_name: airline?.airline_name || "",
      iata_code: airline?.iata_code || "",
      icao_code: airline?.icao_code || ""
    }));

    const search = inputValue.toLowerCase();

    // 1️⃣ EXACT MATCH
    const exact = airlines.filter((a) =>
      a.iata_code.toLowerCase() === search ||
      a.airline_name.toLowerCase() === search
    );

    // 2️⃣ STARTS WITH
    const startsWith = airlines.filter((a) =>
      (a.iata_code.toLowerCase().startsWith(search) ||
       a.airline_name.toLowerCase().startsWith(search)) &&
      !(a.iata_code.toLowerCase() === search ||
        a.airline_name.toLowerCase() === search)
    );

    // 3️⃣ CONTAINS ANYWHERE
    const contains = airlines.filter((a) =>
      (a.iata_code.toLowerCase().includes(search) ||
       a.airline_name.toLowerCase().includes(search)) &&
      !(
        a.iata_code.toLowerCase().startsWith(search) ||
        a.airline_name.toLowerCase().startsWith(search)
      )
    );

    return [...exact, ...startsWith, ...contains];
  } catch (error) {
    console.error("Error fetching airlines:", error);
    return [];
  }
};



  const fetchInitialAirports = async () => {
    try {
      // Fetch initial airline options
      const airlineResponse = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airlines?sortby=airline_name`
      );
      if (airlineResponse.data && airlineResponse.data.Airlines) {
        const airlineOptions = airlineResponse.data.Airlines.map((airline) => ({
          value: airline.id,
          label: `${airline.airline_name} ${
            airline.iata_code ? `(${airline.iata_code})` : ""
          }`,
           iata_code: airline?.iata_code,
              icao_code: airline?.icao_code,
        }));
        setDefaultAirlineOptions(airlineOptions);
      }

      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`
      );
      if (response.data && response.data.Airports) {
        const options = response.data.Airports.map((airport) => ({
          value: airport.id,
          label: `${airport.airport_name.replace(
            /[\n\u0000-\u001F\u007F-\u009F]/g,
            ""
          )} (${airport.iata_code})`,
        }));

        setDefaultOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  useEffect(() => {
    fetchInitialAirports();
  }, []);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      // width: "280px",
      // maxWidth: "280px",
      // minWidth: "280px",

      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
  };

        const [opened, { open:flightDetailsOpen, close:flightDetailsClose }] = useDisclosure(false);
  const [flightDetails, setFlightDetails] = useState(null)
const [indivisualFlight,setIndivisualFlight]=useState(null)
  const [backdropOpen, setBackdropOpen] = useState(false)
  

  useEffect(() => {
  const flightData = localStorage.getItem("flightData");

  if (flightData) {
    setFlightData(JSON.parse(flightData));

    
    }


    const flightDataRoute = localStorage.getItem("flightDataRoute");
    console.log(flightDataRoute)

  if (flightDataRoute) {
    setFlightDataRoute(JSON.parse(flightDataRoute));

    
    }
    

  }, []);
  
  // console.log(flightDataRoute)
 
const navigate = useNavigate()

  const handleViewMore = (flight) => {
   setBackdropOpen(true)


    axios.get(`${base_url.api1}/users/org_flight_stats_live_tracking?flight_id=${flight?.flight_id}`)
      .then((response) => {
        const flightDetails = response.data.Flight_Track;
      setBackdropOpen(false)
        if (flightDetails) {
          //   setFlightDetails(flightDetails)
          // setIndivisualFlight(flight)

          if (flightData) {
             localStorage.setItem("flightData", JSON.stringify(flightData));
          }

      localStorage.setItem("searchMethod", JSON.stringify(searchMethod));



          if (flightDataRoute) {
             localStorage.setItem("flightDataRoute", JSON.stringify(flightDataRoute));
            
          }

    navigate("/flight-live-tracking", {
      state: {
        flightLiveDetails:flightDetails,
        indivisualFlight:flight
      }
    });

        // flightDetailsOpen();
        }
      
      })
      
      .catch((error) => {
        setBackdropOpen(false)
         setFlightDetails(null)
          setIndivisualFlight(null)
        console.error("Error fetching flight details:", error);
      });
    
    


  };

  return (
    <div>
      <Nav />
       <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropOpen}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
     


<Modal
        opened={opened}
        onClose={flightDetailsClose}
        title="Flight Live Tracking"
        fullScreen   transitionProps={{ transition: "slide-up" }}    >
        

        <FlightStatsDetails flightLiveDetails={flightDetails} indivisualFlight={indivisualFlight} />

      </Modal>
      


      <div className="historic-wrapper">
        <div className="historic-container">
          <div className="historic-header" style={{marginBottom:"0px"}}>
            <h2>Flight Schedule</h2>
           

           
              

            <div className="search-tab-tracking">
                <Radio.Group
              mt={'xl'}
              w={'100%'}
                                                        value={searchMethod}
                                          onChange={(value) => {
                                                                        
                
                                            // 1️⃣ Clear saved data in localStorage
  localStorage.removeItem('airportFormData');
  localStorage.removeItem('airlineFormData');
  localStorage.removeItem('flightData');
  localStorage.removeItem('flightDataRoute');

  // 2️⃣ Reset both forms to clean empty state
  resetFlightForm({
    airline: "",
    flightNumber: "",
    departureDate: moment().format("MM-DD-YYYY"),
  });

  resetAirportForm({
    arrivalAirport: "",
    departureAirport: "",
    date: moment().format("MM-DD-YYYY"),
  });

  // 3️⃣ Clear your state variables
  setFlightData(null);
  setFlightDataRoute(null);

  // 4️⃣ Set the active search method
  setSearchMethod(value);
                                            setFlightData(null)
                                            setFlightDataRoute(null)
                                           setSearchMethod(value)
                                                                      }}
                                                    >
                          <div className="claim-form-radio-wrapper new-search-by-method " >
                            
                                                        <Radio
                                                          color="red"
                                                          // checked
                                                          variant="outline"
                                                          value={"by_flight"}
                              label="Search by Flight"
                    size="sm"
                    w={"100%"}
                                            />
                                            
                                                        <Radio
                                                          color="red"
                                                          variant="outline"
                                                          value={"by_airport"}
                              label="Search by Airport"
                    size="sm"
                     w={"100%"}
                              
                    />
                    
                         <Radio
                                                          color="red"
                                                          variant="outline"
                                                          value={"by_route"}
                              label="Search by Route"
                              size="sm"
                               w={"100%"}
                                                        />
                                                      </div>
                                                    </Radio.Group>
            </div>    

          
                   
            
          </div>


        
        </div>

        {
          searchMethod === "by_flight" && <div className="search-by-wrapper">
          <h3 className="search-by-header">
            Flight by Flight
          </h3>

          <div className="search-historic-container">
              <form onSubmit={flightFormHandleSubmit(onSubmit)} className="space-y-4">

          
  <div className="grid-two" style={{marginBottom:"20px"}}>
                    <div className="custom-input">

                        <label className="input-label">
                        Search by
                       
                      </label>

                        <Radio.Group
                                                        value={searchBy}
                                          onChange={(value) => {
                                                                        
                
                                           setSearchBy(value)
                                                                      }}
                                                    >
                          <div className="claim-form-radio-wrapper">
                            
                                                        <Radio
                                                          color="red"
                                                          // checked
                                                          variant="outline"
                                                          value={"airline_name"}
                              label="Airline name"
                              size="sm"
                                            />
                                            
                                                        <Radio
                                                          color="red"
                                                          variant="outline"
                                                          value={"iata_code"}
                              label="Airline code"
                              size="sm"
                              
                                                        />
                                                      </div>
                                                    </Radio.Group>
                    </div>
                    

                  

                   
                  </div>
          
            <div className="grid-three">
              <div className="custom-select" style={{ width: "100%" }}>
                 {/* <div className="airline-radio-wrapper">
                
                                        <Radio.Group
                                                                      value={searchBy}
                                          onChange={(value) => {
                                                                        
                
                                           setSearchBy(value)
                                                                      }}
                                                                    >
                                          <div className="claim-form-radio-wrapper">
                                            <label className="search-by-label">Search by:</label>
                                                                        <Radio
                                                                          color="red"
                                                                          // checked
                                                                          variant="outline"
                                                                          value={"airline_name"}
                                              label="Airline name"
                                              size="sm"
                                                            />
                                                            
                                                                        <Radio
                                                                          color="red"
                                                                          variant="outline"
                                                                          value={"iata_code"}
                                              label="Airline code"
                                              size="sm"
                                              
                                                                        />
                                                                      </div>
                                                                    </Radio.Group>
                                      </div> */}
                <span className="select-label">
                  Airline <span style={{ color: "#de8385" }}> *</span>
                </span>
                <div
                  className="select-box"
                  style={{
                    borderColor: "#E6F6FF",
                    backgroundColor: "#e8eef7",
                  }}
                >
                  <Controller
                    control={flightFormControl}
                    name="airline"
                    rules={{ required: "Airline is required" }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions={false}
                        defaultOptions={defaultAirlineOptions}
                        loadOptions={loadAirlineOptions}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Search airline"
                        styles={selectStyles}
                      />
                    )}
                  />
                </div>
                {flightFormErrors.airline && (
                  <p className="errormessage">{flightFormErrors.airline.message}</p>
                )}
              </div>

              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Flight number
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="flightNumber"
                  control={flightFormControl}
                  rules={{
                    required: "Flight Number is Required",
                    validate: (value) => {
                      if (!/^[a-zA-Z0-9]+$/.test(value)) {
                        return "Only letters and numbers are allowed";
                      }
                      if (value.length > 10) {
                        // Change to 7 if needed
                        return "Maximum 10 characters allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter flight number"
                      type="text"
                      maxLength={10}
                      onChange={(e) => {
                        const cleanedValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        field.onChange(cleanedValue);
                      }}
                    />
                  )}
                />
                {flightFormErrors.flightNumber && (
                  <p className="errormessage">{flightFormErrors.flightNumber.message}</p>
                )}
              </div>

              <div className="custom-date-time-container ">
                <label className="custom-date-time-label">
                  Scheduled departure date
                  <span style={{ color: "#de8385" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <div className="custom-date-time-box" style={{justifyContent:"space-between"}}>
                    <Controller
                      name={`departureDate`}
                      control={flightFormControl}
                      rules={{
                        required: "Departure Date is required",
                        validate: validateDateFormat,
                      }}
                      render={({ field }) => (
                        <CustomDOBPicker
                          {...field}
                          inputRequired={true}
                          placeholder="Choose date"
                          inputClassName="custom-date-input"
                          onChange={(value) => {
                            field.onChange(value);
                          }}
                        />
                      )}
                    />
                  </div>{" "}
                  {flightFormErrors.departureDate && (
                    <p className="errormessage" style={{ marginTop: "12px" }}>
                      {flightFormErrors.departureDate.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "40px",
              }}
            >
              <CustomButton btnText={"Search"} style={{ width: "200px" }} />
            </div>
          </form>

              
               {flightData &&
            flightData.length > 0 &&
            !loading &&
            flightData.map((flight, index) => {
              return <FlightRouteCard flight={flight} key={index} handleViewMore={handleViewMore} />;
            })}

          {flightData?.length === 0  && !loading && (
            <div className="loading-div">No Data Found</div>
          )}

          {loading && (
            <div className="loading-div">
              <Loader />
            </div>
          )}

          {/* {flightData &&
            flightData.length > 0 &&
            !loading &&
            flightData.map((flight, index) => {
              return <FlightCard flight={flight} key={index} />;
            })}

          {!flightData && !loading && (
            <div className="loading-div">No Data Found</div>
          )}

          {loading && (
            <div className="loading-div">
              <Loader />
            </div>
          )} */}
          </div>
        </div>
        }



         {
         ( searchMethod === "by_airport" || searchMethod === "by_route") && <div className="search-by-wrapper">
          <h3 className="search-by-header">
            Search by {searchMethod === "by_airport" ? "Airport":"Route"}
          </h3>

          <div className="search-historic-container">
              <form onSubmit={airportFormHandleSubmit(airportFormOnSubmit)} className="space-y-4">

          
  {/* <div className="grid-two" style={{marginBottom:"20px"}}>
                    <div className="custom-input">

                        <label className="input-label">
                        Search by
                      
                      </label>

                        <Radio.Group
                                                        value={searchBy}
                                          onChange={(value) => {
                                                                        
                
                                           setSearchBy(value)
                                                                      }}
                                                    >
                          <div className="claim-form-radio-wrapper">
                            
                                                        <Radio
                                                          color="red"
                                                         
                                                          variant="outline"
                                                          value={"airline_name"}
                              label="Airline name"
                              size="sm"
                                            />
                                            
                                                        <Radio
                                                          color="red"
                                                          variant="outline"
                                                          value={"iata_code"}
                              label="Airline code"
                              size="sm"
                              
                                                        />
                                                      </div>
                                                    </Radio.Group>
                    </div>
                    

                  

                   
                </div> */}
                
                <div className="grid-three">
                   {/* <div className="custom-select" style={{ width: "100%" }}>
                
                <span className="select-label">
                  Airline <span style={{ color: "#de8385" }}> *</span>
                </span>
                <div
                  className="select-box"
                  style={{
                    borderColor: "#E6F6FF",
                    backgroundColor: "#e8eef7",
                  }}
                >
                  <Controller
                    control={airportFormControl}
                    name="airline"
                    rules={{ required: "Airline is required" }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions={false}
                        defaultOptions={defaultAirlineOptions}
                        loadOptions={loadAirlineOptions}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Search airline"
                        styles={selectStyles}
                      />
                    )}
                  />
                </div>
                {airportFormErrors.airline && (
                  <p className="errormessage">{airportFormErrors.airline.message}</p>
                )}
              </div> */}
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Departure Airport
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                       
                          <div style={{ width: "100%" }}>
                            {/* <div>Coming in else</div> */}
                            <Controller
                              name={`departureAirport`}
                              control={airportFormControl}
                              
                              rules={{
                                required: "Departure airport is required",
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  defaultOptions={defaultOptions}
                                  
                                  value={
                                    field.value
                                      // ? {
                                      //     label: field.value,
                                      //     value: field.value,
                                      //   }
                                      // : null
                                  }
                                  placeholder="Select departure airport"
                                  onChange={field.onChange}
                                  // onChange={(selectedOption) => {
                                  //   console.log(selectedOption)
                                  //   field.onChange(selectedOption?.label || "");
                                    
                                  // }}
                                />
                              )}
                            />
                         
                              
                           
                      </div>
                      
                        
                    </div>
                    
                     {airportFormErrors.departureAirport && (
                  <p className="errormessage">{airportFormErrors.departureAirport.message}</p>
                )}

                         
                  </div>
                  
                  <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Arrival Airport
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                       
                          <div style={{ width: "100%" }}>
                            {/* <div>Coming in else</div> */}
                            <Controller
                              name={`arrivalAirport`}
                              control={airportFormControl}
                              
                              rules={{
                                required: "Arrival airport is required",
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  defaultOptions={defaultOptions}
                                  
                                  value={
                                    field.value
                                      // ? {
                                      //     label: field.value,
                                      //     value: field.value,
                                      //   }
                                      // : null
                                  }
                                  placeholder="Select arrival airport"
                                  // onChange={(selectedOption) => {
                                    
                                  //   field.onChange(selectedOption?.label || "");
                                    
                                  // }}
                                  onChange={field.onChange}
                                />
                              )}
                            />
                         
                              
                           
                          </div>
                        
                    </div>
                    
                     {airportFormErrors.arrivalAirport && (
                  <p className="errormessage">{airportFormErrors.arrivalAirport.message}</p>
                )}


                         
                  </div>
                  
                   <div className="custom-date-time-container">
                <label className="custom-date-time-label">
                  Date
                  <span style={{ color: "#de8385" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <div className="custom-date-time-box" style={{justifyContent:"space-between"}}>
                    <Controller
                      name={`date`}
                      control={airportFormControl}
                      rules={{
                        required: "Departure Date is required",
                        validate: validateDateFormat,
                      }}
                      render={({ field }) => (
                        <CustomDOBPicker
                          {...field}
                          inputRequired={true}
                          placeholder="Choose date"
                          inputClassName="custom-date-input"
                          onChange={(value) => {
                            field.onChange(value);
                          }}
                        />
                      )}
                    />
                  </div>{" "}
                  {airportFormErrors.date && (
                    <p className="errormessage" style={{ marginTop: "12px" }}>
                      {airportFormErrors.date.message}
                    </p>
                  )}
                </div>
                  </div>
                </div>
          
            {/* <div className="grid-three" style={{marginTop:"30px"}}>
             

             

             

                   <div className="custom-select" style={{ width: "100%" }}>
                
                <span className="select-label">
                  Time <span style={{ color: "#de8385" }}> *</span>
                </span>
                <div
                  className="select-box"
                  style={{
                    borderColor: "#E6F6FF",
                    backgroundColor: "#e8eef7",
                  }}
                >
                  <Controller
                    control={airportFormControl}
                    name="time"
                    rules={{ required: "Time is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        cacheOptions={false}
                        options={timeOptions}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Select Time"
                        styles={selectStyles}
                      />
                    )}
                  />
                </div>
                {airportFormErrors.time && (
                  <p className="errormessage">{airportFormErrors.time.message}</p>
                )}
              </div>
                  

            </div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "40px",
              }}
            >
              <CustomButton btnText={"Search"} style={{ width: "200px" }} />
            </div>
          </form>

          {flightDataRoute &&
            flightDataRoute.length > 0 &&
            !loading &&
            flightDataRoute.map((flight, index) => {
              return <FlightRouteCard flight={flight} key={index} handleViewMore={handleViewMore} />;
            })}

          {flightDataRoute?.length === 0  && !loading && (
            <div className="loading-div">No Data Found</div>
          )}

          {loading && (
            <div className="loading-div">
              <Loader />
            </div>
          )}
          </div>
        </div>
        }

        


        
        
      </div>
      <Footer />
    </div>
  );
};

export default FlightTracking;
